<template>
    <div>
        <BOverlay :show="is_load" rounded="sm">
            <div class="app_vue_list" >
                
                <!-- filter -->
                <div class="filter_block mb-3">
                    <application_filter    v-model:filter="filter"
                                           @search_called="handleSearch"
                                           @clean_filter="handleCleanFilters"></application_filter>
                </div>
                
                <BTable  :thead-class="head_class" :tbody-tr-class="rowClass" hover responsive :items="rows" :fields="table_fields">
                    <!-- HEAD FIELDS -->
                    <template v-slot:head(id)="data">
                        <grid :list_ordering="'id'" field_name="ID" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(contragent)="data">
                        <grid :list_ordering="'author_id'" field_name="Контрагент" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(tender_user)="data">
                        <grid :list_ordering="'author_id'" field_name="Надіслав" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(contact_tel)="data">
                        <grid :list_ordering="'contact_tel'" field_name="Телефон" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_create)="data">
                        <grid :list_ordering="'date_create'" field_name="Створена" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(human_status)="data">
                        <grid :list_ordering="'human_status'" field_name="Статус" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(tender)="data">
                        <grid :list_ordering="'tender_id'" field_name="Тендер" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(info)>
                        Другий тур
                    </template>
                    
                    <template v-slot:head(edit)>
                        <i class="far fa-edit"></i>
                    </template>
                    
                    
                    <!-- ROW FIELDS -->
                    
                    <template v-slot:cell(id)="data">
                        <BTooltip>
                            <template #target>
                                <a  :href="'/zaiavky-na-uchast/' + data.item.id">
                                    {{data.item.id}}
                                </a>
                            </template>
                            Переглянути заявку
                        </BTooltip>
                    </template>
                    
                    <template v-slot:cell(contragent)="data">
                        <BTooltip>
                            <template #target>
                                <a  :href="'/kontrahenty/' + data.item.tender_user?.id">
                                    {{data.item.tender_user?.company}}
                                </a>
                            </template>
                           Профіль контрагента
                        </BTooltip>
                    </template>
                    
                    <template v-slot:cell(tender)="data">
                        <BTooltip>
                            <template #target>
                                <a  :href="'/tender/show/' + data.item.tender_item_id">
                                    {{data.item.tender_name}}
                                </a>
                            </template>
                            Переглянути Тендер
                        </BTooltip>
                    </template>
                    
                    <template v-slot:cell(contact_tel)="data">
                        {{data.item.tender_user?.contact_tel}}
                    </template>
                    
                    <template v-slot:cell(tender_user)="data">
                        {{data.item.tender_user?.contact_name}}
                    </template>
                    
                    <template  v-slot:cell(human_status)="data">
                        <span :class="data.item.status == 'new' ? 'text-danger' : ''">
                            {{data.item.human_status}}
                        </span>
                    </template>
                    
                    <template v-slot:cell(info)="data">
                    
                    </template>
                    
                </BTable>
            </div>
            
            <div class="pt-4" v-if="rows.length > 0">
                <pagination
                    key="down"
                    :total="pagination.total"
                    :limit="pagination.limit"
                    :current="pagination.pagesCurrent"
                    @page-change="handlePageChange">
                </pagination>
            </div>
        
        </BOverlay>
    </div>
</template>


<script>

import {
    BButton,
    BTable,
    BOverlay,
    BTooltip,
} from 'bootstrap-vue-next';

import grid from "../../../shared/list/grid/grid.vue";
import pagination from "../../../shared/list/pagination/pagination.vue";
import List_filter from "../../../shared/list/filter/list_filter.vue";
import Application_filter from "./application_filter.vue";
import protocol_filter from "../../protocols/list/protocol_filter.vue";

export default {
    name: "application_table",
    
    props : {
    
    },
    
    components : {
        protocol_filter,
        Application_filter,
        List_filter,
        BTable,
        BOverlay,
        BButton,
        BTooltip,
        grid,
        pagination
    },
    
    data() {
        return {
            rows : [],
            is_load : true,
            
            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },
            
            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },
            
            filter: {
                search: "",
                status : "",
            },
            
            fields : [
                { key : 'id',label: 't.id ',class:''},
                { key : 'contragent',},
                { key : 'tender_user',},
                { key : 'contact_tel',},
                { key : 'date_create',label: 't.date_create ',class:''},
                { key : 'human_status',label: 't.text_status ',class:''},
                { key : 'tender',label: 't.tender_id ',class:'', thStyle: { minWidth: '347px'}},
                { key : 'info',label: 't.info ',class:'', },
                { key : 'edit'},
            ],
        }
    },
    
    mounted() {
        this.load_items();
    },
    
    created() {
    
    },
    
    methods : {
        
        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },
        
        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },
        
        handleSearch(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },
        
        handleCleanFilters() {
            
            this.filter = {
                search: "",
            };
            
            this.list = {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            
            this.list.start = 0;
            this.load_items();
        },
        
        edit_view(item) {
            if ((item.status == 'new') || (item.status == 'reject')) {
                window.location = this.href_edit + item.id;
            } else {
                window.location = this.href_view + item.id;
            }
        },
        
        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },
        
        async load_items() {
            this.is_load = true;
            this.rows = [];
            
            await api.post('/tenders/sales/tenders/applications',{
                filter  : this.filter,
                list    : this.list
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rows = data.data;
                    
                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            }).catch(e => {
                this.is_load = false;
                this.rows = [];
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        rowClass(item) {
            if (!item) return;
            return 'app_' + item.status;
        }
    },
    
    computed : {
        
        head_class() {
        },
        
        table_fields() {
            return this.fields;
        }
    }
    
}
</script>


<style scoped>

</style>